import APP_ACTIONS from '../constants/app-actions';
import APP_DEFAULTS from '../constants/app-defaults';

const initialState = {
    timeMinutesLastAlert: 0, // This value is only for computing the earliest alert.
    timeSecondsLeft: 0,
    lastAlert: false,
    hasExtraTimeCheckout: false,

    activeCart: false, // This value is set to false because of waiting for a response from the backend.
    cartRemoval: Number(process.env.REACT_APP_EMPTY_CART_IN_SECONDS) || 0,
    gracePeriod: APP_DEFAULTS.extraMinutesOnCheckout * 60,
};

const cartState = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.SET_ACTIVE_CART:
        return { ...state, activeCart: action.payload };
    case APP_ACTIONS.SET_CONFIGS_ACTIVE_CART:
        return {
            ...state,
            activeCart: action.payload.activeCart,
            cartRemoval: action.payload.cartRemoval,
            gracePeriod: action.payload.gracePeriod,
        };
    case APP_ACTIONS.UPDATE_MINUTES_TIME_LEFT_CART:
        return {
            ...state, timeMinutesLastAlert: action.payload,
        };
    case APP_ACTIONS.UPDATE_SECONDS_TIME_LEFT_CART:
        return {
            ...state, timeSecondsLeft: action.payload,
        };
    case APP_ACTIONS.SET_LAST_ALERT_TIME_LEFT_CART:
        return {
            ...state, lastAlert: action.payload,
        };
    case APP_ACTIONS.SET_EXTRA_TIME_CHECKOUT:
        return {
            ...state, hasExtraTimeCheckout: action.payload,
        };
    default:
        return state;
    }
};

export default cartState;



/** WEBPACK FOOTER **
 ** ./src/reducers/cart-state.js
 **/